import cx from "classnames"
import * as React from "react"
import * as i18n from "tb-i18n"
import Card from "./card"
import { CustomerCarouselDataType } from "../homepage.module"
import { getGlobalConfig } from "../../../lib/global-config"
import { getTransformStyle } from "../../../lib/util"
const styles = require("./main.styl")

interface Props {
    data: CustomerCarouselDataType[]
}

interface State {
    currentIndex: number
    cardWidth: number
    loopData: CustomerCarouselDataType[]
    dataLength: number
    fold: boolean
    loading: boolean
}

export default class CustomerCarousel extends React.PureComponent<
    Props,
    State
> {
    private card: Card
    private mobileWidth = 768
    constructor(prop) {
        super(prop)
        const data = [...this.props.data.map(i => ({ ...i }))]
        let loopData = data
        if (data.length < 8) {
            const length = data.length
            const before = data
                .slice(length / 2)
                .map(i => ({ ...i, name: `ex-${i.name}` }))
            const after = data
                .slice(0, length / 2)
                .map(i => ({ ...i, name: `ex-${i.name}` }))
            loopData = [...before, ...data, ...after]
        }
        this.state = {
            currentIndex: 2,
            cardWidth: 0,
            loopData,
            fold: true,
            dataLength: length,
            loading: true
        }
    }

    componentDidMount() {
        this.resetCardWidth()
        this.initFold()
        window.addEventListener("resize", this.resetCardWidth)
        window.addEventListener("resize", this.initFold)
    }

    componentDidUpdate() {
        this.resetCardWidth()
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resetCardWidth)
        window.removeEventListener("resize", this.initFold)
    }

    render() {
        const { fold, loading } = this.state
        const { lang } = getGlobalConfig()
        return (
            <div
                className={ cx(
                    styles["customer-carousel"],
                    { fold },
                    { loading }
                ) }
            >
                <div className="customer-carousel-wrap">
                    <div
                        className={ cx("customer-carousel-cards", {
                            "large-height": lang === "en"
                        }) }
                    >
                        {this.renderCards()}
                        {this.renderTip()}
                    </div>
                </div>
                <i
                    className="customer-carousel-controler customer-carousel-controler-left"
                    onClick={ this.prevImage }
                >
                    <span className="icon icon-chevron-left" />
                </i>
                <i
                    className="customer-carousel-controler customer-carousel-controler-right"
                    onClick={ this.nextImage }
                >
                    <span className="icon icon-chevron-right" />
                </i>
            </div>
        )
    }

    renderCards() {
        const { currentIndex, cardWidth, loopData } = this.state
        const { data } = this.props
        let targetData = data
        if (window.innerWidth > this.mobileWidth) {
            targetData = loopData
        }
        return targetData.map(
            ({ image, logo, describe, name, link }, index) => {
                let relativeIndex = index - currentIndex - 1
                const length = targetData.length
                if (relativeIndex < -2) {
                    relativeIndex += length
                } else if (relativeIndex > length - 3) {
                    relativeIndex -= length
                }
                let cardStyle = {
                    ...getTransformStyle(
                        `translate3d(${Math.floor(
                            relativeIndex * (cardWidth + 44)
                        )}px, 0, 0)`
                    )
                }
                if (relativeIndex > 3 || relativeIndex < -1) {
                    cardStyle = Object.assign(cardStyle, { transition: "0s" })
                }
                return (
                    <Card
                        ref={ ref => (this.card = ref) }
                        key={ name }
                        style={ cardStyle }
                        image={ image }
                        logo={ logo }
                        describe={ describe }
                        link={ link }
                    />
                )
            }
        )
    }
    renderTip() {
        const { fold } = this.state
        if (fold) {
            return (
                <div className="customer-carousel-tip" onClick={ this.unfold }>
                    {i18n.get("homepage.unfold")}
                    <span className="icon icon-chevron-down" />
                </div>
            )
        }
    }
    unfold = () => {
        this.setState({ fold: false })
    }
    prevImage = () => {
        const { loopData, currentIndex } = this.state
        const loopDataLength = loopData.length
        let index = currentIndex
        index -= 1
        if (index < 0) {
            index = loopDataLength - 1
        }
        this.setState({ currentIndex: index })
    }
    nextImage = () => {
        const { loopData, currentIndex } = this.state
        const loopDataLength = loopData.length
        let index = currentIndex
        index += 1
        if (index >= loopDataLength) {
            index = 0
        }
        this.setState({ currentIndex: index })
    }
    initFold = () => {
        if (window.innerWidth <= this.mobileWidth) {
            this.setState({ fold: true })
        } else {
            this.setState({ fold: false })
        }
    }
    resetCardWidth = () => {
        let width = window.innerWidth - 160
        let cardWidth
        if (width > 1440) {
            width = 1440
        }
        if (window.innerWidth >= 1040) {
            cardWidth = (width - 88) / 3
        } else {
            cardWidth = (width - 44) / 2
        }
        this.setState({ cardWidth, loading: false })
    }
}
